import type { Instance, SnapshotOut } from 'mobx-state-tree'
import { types } from 'mobx-state-tree'
import type { ReactElement } from 'react'

export const ConfirmationStoreModel = types
  .model('ConfirmationStore')
  .volatile<ConfirmationStoreVolatileProps>(() => ({
    confirmations: {},
  }))
  .actions(self => ({
    removeConfirmation(id: string) {
      delete self.confirmations[id]
    },
  }))
  .actions(self => ({
    addConfirmation(confirmation: ConfirmationStoreVolatileProps['confirmations'][string]) {
      const { id = String(Date.now()), labels, onCancel, onConfirm, ...rest } = confirmation

      const { confirm = 'Confirm', cancel = 'Cancel' } = labels ?? {}

      async function modifiedOnCancel() {
        await onCancel()
        self.removeConfirmation(id)
      }

      async function modifiedOnConfirm() {
        await onConfirm()
        self.removeConfirmation(id)
      }

      self.confirmations[id] = {
        id,
        labels: { confirm, cancel },
        onCancel: modifiedOnCancel,
        onConfirm: modifiedOnConfirm,
        ...rest,
      }
      return id
    },
  }))

export interface ConfirmationStoreVolatileProps {
  confirmations: Record<
    string,
    {
      id?: string
      onConfirm: () => Promise<void> | void
      onCancel: () => Promise<void> | void
      labels?: { confirm?: string; cancel?: string }
      title?: string
      content?: string
      Content?: ReactElement
      screenContentContainerStyle?: Record<string, any>
    }
  >
}

export interface ConfirmationStore extends Instance<typeof ConfirmationStoreModel> {}
export interface ConfirmationStoreSnapshot extends SnapshotOut<typeof ConfirmationStoreModel> {}
